import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Institutes(state = initialState, action) {
  switch (action.type) {
    case userConstants.INSTITUTES_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.INSTITUTES_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.INSTITUTES_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}